const appInfo = {
    title: 'Prospero'
};
export default appInfo;

